import type { AnimationConfig } from '../../Animate.types'

const getDelay = (animationCfg: AnimationConfig): number => {
  return animationCfg.delay || 0
}

export default getDelay
